
import { defineComponent } from 'vue'
import DeleteIcon from './DeleteIcon.vue'

export default defineComponent({
    name: 'ColumnControls',
    components: {
        DeleteIcon,
    },
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        showRemove: {
            type: Boolean,
            default: true,
        },
    },
    emits: ['add-left', 'add-right', 'remove'],
})
